import styled from 'styled-components';

export const EmptySearchWrapper = styled.div`
  margin-top: 120px;
`;
